export default __webpack_public_path__ + "static/media/demo5.415bd046.mp4";